export default "__VITE_ASSET__BQdejMmL__"